import React from "react";
import MarketCentral from "../../organism/market/marketCentral";
import MarketHeader from "../../organism/market/marketHeader";

const MarketPage = () => {
    return (
        <>
            <MarketHeader/>
            <MarketCentral/>
        </>
    )
}

export default MarketPage 